const t=300,e=(t,e=300)=>{let o;return function(...i){clearTimeout(o),o=setTimeout(()=>t.apply(this,i),e)}};export{t as DEFAULT_DEBOUNCE_TIME_MS,e as debounce};
//# sourceMappingURL=debounce.js.map
